import { ImagePosition } from '@silvertours/common-landingpages-view';

export type LayoutFlow = 'top' | 'bottom' | 'left' | 'right';

export type HasLayoutFlow = {
  layoutFlow?: LayoutFlow;
};

export const selectLayoutFlow = (position: ImagePosition) => position;
